<a
    *ngIf="!isSubMenu"
    tabindex="-1"
    class="app-nav-item"
    (mouseenter)="mouseEnter(menuTrigger)"
    (mouseleave)="mouseLeave(menuTrigger)"
    [matMenuTriggerFor]="menu"
    [ngClass]="{ 'menu-open': isMenuOpen }"
    #menuTrigger="matMenuTrigger"
    [routerLink]="item.routePath"
    (click)="onClick(item)"
    [attr.automation-id]="item.label | translate | toAutomationId: { prefix: 'tab' }"
>
    <div class="label">
        <p-icon *ngIf="item.settings?.icon" class="icon" [name]="item.settings?.icon!"></p-icon>
        <span> {{ item.label | translate }}</span>
        <a *ngIf="badge && myItems" class="badge" [matTooltip]="badge.tooltip | translate" (click)="onBadgeClick($event, badge)">
            {{ myItems[badge.value] }}
        </a>
    </div>
</a>
<a
    *ngIf="isSubMenu"
    class="p-menu-nav-item"
    (mouseenter)="mouseEnter(menuTrigger)"
    (mouseleave)="mouseLeave(menuTrigger)"
    mat-menu-item
    [matMenuTriggerFor]="menu"
    [attr.automation-id]="item.label | translate | toAutomationId: { prefix: 'tab' }"
>
    {{ item.label | translate }}
</a>
<mat-menu #menu="matMenu" [hasBackdrop]="false" class="p-menu p-menu-nav-item">
    <div (mouseenter)="mouseEnter(menuTrigger)" (mouseleave)="mouseLeave(menuTrigger)">
        <ng-container *ngFor="let subItem of item.menu; trackBy: menuId">
            <span *ngIf="subItem.settings?.showDivider" class="divider"></span>
            <div class="mat-menu-item-container">
                <a
                    *ngIf="!subItem.menu && !subItem.settings?.openInNewTab"
                    mat-menu-item
                    (click)="onClick(subItem)"
                    [routerLink]="subItem.routePath"
                    [attr.automation-id]="subItem.label | translate | toAutomationId: { prefix: 'tab' }"
                >
                    {{ subItem.label | translate }}
                </a>
                <p-nav-item
                    *ngIf="subItem.menu"
                    [item]="subItem"
                    [isSubMenu]="true"
                    (triggerClearTimeout)="handleCLearTimeOut()"
                    (triggerMouseLeave)="handleChildMouseLeave()"
                >
                </p-nav-item>
                <div
                    *ngIf="!subItem.menu && subItem.settings?.openInNewTab"
                    mat-menu-item
                    (click)="openInNewTab(subItem)"
                    [attr.automation-id]="subItem.label | translate | toAutomationId: { prefix: 'tab' }"
                >
                    {{ subItem.label | translate }}
                </div>
            </div>
        </ng-container>
    </div>
</mat-menu>
